import { IEntityType, IListingTypeID, IMHBOListing } from 'mhbo-js'
import React, { Suspense } from 'react'
import { IntlProvider } from 'react-intl'
import NO_PHOTO from '../../../assets/no_photo.png'
import { IProps } from './interfaces'
import { KeyboardArrowLeft, KeyboardArrowRight } from '@mui/icons-material'

const CommunityDetails = React.lazy(() => import('./CommunityDetails'))
const HomeDetails = React.lazy(() => import('./HomeDetails'))

const Rollover: React.FC<IProps> = (props: IProps) => {
  const {
    clientX,
    clientY,
    selectedDetail,
    byIds,
    openSelectedUrl,
    childmarkers,
    updateSelectedLocation,
  } = props
  const clusterLength = childmarkers.length
  const selectedIndex = childmarkers.indexOf(selectedDetail)
  let detailId = byIds.filter((e) => e.id === selectedDetail) as any
  if (detailId.length > 0) {
    detailId = Object.assign({}, detailId[0])

    if (
      [IEntityType.Community, IEntityType.Dealer].includes(detailId.entityType)
    ) {
      detailId.forSaleHomes =
        detailId.mobilehomes.filter(
          (home: IMHBOListing) =>
            home.listingTypeId &&
            [
              IListingTypeID.ForSale,
              IListingTypeID.ForRentAndToOwn,
              IListingTypeID.ForRentOrForSale,
            ].includes(home.listingTypeId)
        ).length || 0
      detailId.forRentHomes =
        detailId.mobilehomes.filter(
          (home: IMHBOListing) =>
            home.listingTypeId &&
            [
              IListingTypeID.ForRent,
              IListingTypeID.ForRentAndToOwn,
              IListingTypeID.ForRentOrForSale,
            ].includes(home.listingTypeId)
        ).length || 0
    }
  }

  const visibility = selectedDetail === -1 ? 'hidden' : 'visible'
  let x = clientX - 143 < 0 ? clientX + 15 : clientX - 143
  let y = clientY - 215 < 0 ? clientY + 25 : clientY - 215

  if (detailId.entityType === IEntityType.Community) {
    if (clusterLength > 0) {
      y = y - 14 < 0 ? y : y - 14
    }
  }

  if (clusterLength > 0) {
    y = y - 76 < 0 ? y : y - 76
  }

  let imgLink = detailId.photoLarge
  if (!detailId.photoLarge || detailId.photoLarge.trim().length === 0) {
    imgLink = NO_PHOTO
  }
  let name = ''
  if ([IEntityType.Community].includes(detailId.entityType)) name = '-community'
  if (
    ![IEntityType.Community, IEntityType.Dealer].includes(detailId.entityType)
  )
    name = '-sale'

  return (
    <IntlProvider locale="en">
      <div
        style={{
          left: `${x}px`,
          top: `${y}px`,
          visibility,
        }}
        onTouchEnd={(e) => e.stopPropagation()}
        className={`rollover__wrapper`}
      >
        {clusterLength > 0 ? (
          <div
            className={`rollover__clustertotal`}
          >{`${clusterLength} items`}</div>
        ) : null}
        {detailId ? (
          <div
            style={{ cursor: 'pointer' }}
            onClick={() => openSelectedUrl(detailId.id)}
          >
            <img
              style={{
                background: `url(${imgLink})`,
              }}
              alt=""
              className={`rollover__image${name}`}
            />
            <div className={`rollover__details_wrapper${name}`}>
              <Suspense fallback={null}>
                {[IEntityType.Community, IEntityType.Dealer].includes(
                  detailId.entityType
                ) ? (
                  <CommunityDetails details={detailId} />
                ) : detailId.entityType === IEntityType.Home ? (
                  <HomeDetails details={detailId} />
                ) : null}
              </Suspense>
            </div>
          </div>
        ) : null}
        {clusterLength > 0 ? (
          <div className={`rollover__clusterpager`}>
            <KeyboardArrowLeft
              style={{
                visibility: selectedIndex !== 0 ? 'visible' : 'hidden',
                cursor: 'pointer',
              }}
              onClick={(event) => {
                event.stopPropagation()
                updateSelectedLocation(childmarkers[selectedIndex - 1])
              }}
            />

            <span className={`rollover__clusterpager__text`}>
              {`
          ${selectedIndex + 1} of ${clusterLength}`}
            </span>
            <KeyboardArrowRight
              style={{
                visibility:
                  selectedIndex !== clusterLength - 1 ? 'visible' : 'hidden',
                cursor: 'pointer',
              }}
              onClick={(event) => {
                event.stopPropagation()

                updateSelectedLocation(childmarkers[selectedIndex + 1])
              }}
            />
          </div>
        ) : null}
      </div>
    </IntlProvider>
  )
}

export default Rollover
